import * as Logger from 'loglevel';
import authService from '../../../../../api-authorization/AuthorizeService'

export default class HubApi {

    resetUserPassword = async (user, newPassword) => {
        var userId = user.userGuid;
        let token = await authService.getAccessTokenAsync();
        const response = await fetch(`/api/hubuser/${userId}/password?newPassword=${newPassword}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'text/json; charset=UTF-8'
            },
            body: `"${newPassword}"`
        });
        Logger.debug('reset password response:', response);
        return response;
    }

}